export const NEWBUILDING_PROMO_BUILDER_OFFERS_CAROUSEL_OPTIONS = {
  spaceBetween: 16,
  slidesPerView: 4,
  slidesPerGroup: 4,
  allowTouchMove: false,
  className: 'newbuilding-promo-builder-offers-carousel',
  testId: 'NewbuildingPromoBuilderOffersCarousel',
};
